/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipHistoricalTrackPost202Response
 */
export interface ShipHistoricalTrackPost202Response {
    /**
     * ID of the job, can be used with /ship/historical/track/{id} to get information about the job
     * @type {string}
     * @memberof ShipHistoricalTrackPost202Response
     */
    id?: string;
}

/**
 * Check if a given object implements the ShipHistoricalTrackPost202Response interface.
 */
export function instanceOfShipHistoricalTrackPost202Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipHistoricalTrackPost202ResponseFromJSON(json: any): ShipHistoricalTrackPost202Response {
    return ShipHistoricalTrackPost202ResponseFromJSONTyped(json, false);
}

export function ShipHistoricalTrackPost202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipHistoricalTrackPost202Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function ShipHistoricalTrackPost202ResponseToJSON(value?: ShipHistoricalTrackPost202Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

